<template>
  <div class="w-full flex gap-4 items-center seperator mt-6">
    <p
      v-for="tab in tabs"
      :key="tab.value"
      :class="modelValue == tab.value ? 'active tab' : 'tab'"
      @click="$emit('update:modelValue', tab.value)"
    >
      {{ tab.name }}
    </p>
    <div class="ml-auto">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Tab {
  name: string
  value: string
}

defineProps<{
  tabs: Tab[]
  modelValue: string
}>()

defineEmits<{
  'update:modelValue': [value: string]
}>()
</script>

<style scoped>
.tab {
  color: #95989c;
  padding: 12px;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  position: relative;
}
.tab.active {
  color: var(--idi-green);
}
.tab.active::after {
  content: '';
  position: absolute;
  border-radius: 4px 4px 0px 0px;
  background: var(--idi-green);
  height: 3px;
  width: 100%;
  left: 0;
  bottom: 0;
}
</style>
